import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-male-tai-chi-yoga-pr': {
			// ?safe&mock-data&utm_source=FB&country=US&area=activity-male-tai-chi-yoga-pr&exp=web_tai_chi_pr_offer_update~1
			landing: {
				experiment: () => import('@/modules/Landing/instances/experiments/web_tai_chi_pr_offer_update'),
			},
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-male-tai-chi-yoga-pr&exp=web_tai_chi_pr_offer_update~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_tai_chi_pr_offer_update/tai-chi-yoga-m-pr'
					),
			},
		},
		'activity-female-tai-chi-walking-pr': {
			// ?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-pr&exp=web_tai_chi_pr_offer_update~1
			landing: {
				experiment: () => import('@/modules/Landing/instances/experiments/web_tai_chi_pr_offer_update'),
			},
			// /result_complete?safe&mock-data&utm_source=FB&country=US&area=activity-female-tai-chi-walking-pr&exp=web_tai_chi_pr_offer_update~1
			paywall: {
				experiment: () =>
					import(
						/* webpackChunkName: "plan" */ '@/modules/Paywall/instances/experiments/web_tai_chi_pr_offer_update/tai-chi-walking-f-pr'
					),
			},
		},
	},
]

export default config
